import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Icon,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const navLinks = [
  { icon: "home", name: "Accueil", route: "/" },
  { icon: "donut_large", name: "Dashboard", route: "/dashboard" },
  { icon: "person", name: "Profil", route: "/profil" },
  { icon: "key", name: "Connexion", route: "/authentication/sign-in" },
];

function DefaultNavbarMobile({ open, close }) {
  return (
    <Dialog
      open={Boolean(open)}
      onClose={close}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          width: "92%",
          maxWidth: 360,
          mx: "auto",
          mt: "80px",
          alignSelf: "flex-start",
          overflow: "hidden",
        },
      }}
      sx={{ "& .MuiBackdrop-root": { backdropFilter: "blur(4px)" } }}
    >
      <DialogContent sx={{ p: 0 }}>
        {/* En-tête */}
        <MDBox
          sx={{
            background: "linear-gradient(135deg, #0A3475, #186A81)",
            py: 2.5,
            px: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <MDTypography variant="h6" color="white" fontWeight="bold">
            Menu
          </MDTypography>
          <IconButton onClick={close} sx={{ color: "rgba(255,255,255,0.8)", p: 0.5 }}>
            <Icon>close</Icon>
          </IconButton>
        </MDBox>

        {/* Liens */}
        <List disablePadding>
          {navLinks.map((link, i) => (
            <MDBox key={link.route}>
              <ListItem disablePadding>
                <ListItemButton
                  component={Link}
                  to={link.route}
                  onClick={close}
                  sx={{
                    py: 0.75,
                    px: 3,
                    "&:hover": { backgroundColor: "#E8F4F6" },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <Icon sx={{ color: "#186A81" }}>{link.icon}</Icon>
                  </ListItemIcon>
                  <ListItemText
                    primary={link.name}
                    primaryTypographyProps={{
                      fontWeight: "medium",
                      color: "#0A3475",
                      textTransform: "capitalize",
                    }}
                  />
                  <Icon sx={{ color: "#999", fontSize: "18px" }}>chevron_right</Icon>
                </ListItemButton>
              </ListItem>
              {i < navLinks.length - 1 && <Divider sx={{ mx: 3 }} />}
            </MDBox>
          ))}
        </List>

        <MDBox sx={{ height: 12 }} />
      </DialogContent>
    </Dialog>
  );
}

DefaultNavbarMobile.propTypes = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  close: PropTypes.oneOfType([PropTypes.func, PropTypes.bool, PropTypes.object]).isRequired,
};

export default DefaultNavbarMobile;
